import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
//import Leaderboards from '../views/Leaderboards';
import Login from '../views/Login';
import Logout from '../views/Logout';
import Register from '../views/Register';
import Runs from '../views/Runs';
import Team from '../views/Team';
import Profile from '../views/Profile';
import PasswordReset from '../views/PasswordReset';
import Activate from '../views/Activate';
import UsersList from '../views/UsersList';
import TeamsList from '../views/TeamsList';
import Wettbewerb from '../views/Wettbewerb.vue';
import AdminRuns from '../views/AdminRuns';
import AdminCompanies from '../views/AdminCompanies';
import ManageChallenges from '../components/admin/ManageChallenges.vue';
import CompanyManager from '../components/user/CompanyManager.vue';
import ManageText from '../components/admin/ManageText.vue';
import Embedded from '../views/Embedded.vue';

// import { component } from 'vue/types/umd';

Vue.use(VueRouter)

const beforeEnter = function(to, from, next) {
  //console.log(to, from);
  if( from.name != null ) {
    Vue.nextTick(function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    });
  }

  next();
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter
  },
  //{
  //  path: '/about',
  //  name: 'About',
  //  // route level code-splitting
  //  // this generates a separate chunk (about.[hash].js) for this route
  //  // which is lazy-loaded when the route is visited.
  //  component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  //},
  /*{
    path: '/rangliste',
    name: 'Leaderboards',
    component: Leaderboards
  },*/
  {
    path: '/users',
    name: 'UsersList',
    component: UsersList,
    beforeEnter
  },
  {
    path: '/teams',
    name: 'TeamsList',
    component: TeamsList,
    beforeEnter
  },
  {
    path: '/login/:inviteId?',
    name: 'Login',
    component: Login,
    beforeEnter
  },
  {
    path: '/register/:inviteId?',
    name: 'Register',
    component: Register,
    beforeEnter
  },
  {
    path: '/activate/:code',
    name: 'Activate',
    component: Activate,
    props: true,
    beforeEnter
  },
  {
    path: '/password-reset/:code',
    name: 'PasswordReset',
    component: PasswordReset,
    beforeEnter
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    beforeEnter
  },
  {
    path: '/runs',
    name: 'Runs',
    component: Runs,
    beforeEnter
  },
  {
    path: '/team/:acceptInviteMass?/:inviteId?',
    name: 'Team',
    component: Team,
    beforeEnter
  },
  {
    path: '/profile/:jumpto?/:inviteId?',
    name: 'Profile',
    component: Profile,
    beforeEnter
  },
  // {
  //   path: '/profile/strava',
  //   name: 'ActivateStrava',
  //   component: Profile,
  //   beforeEnter
  // },
  {
    path: '/wettbewerb',
    name: 'Wettbewerb',
    component: Wettbewerb,
    beforeEnter
  },
  {
    path: '/manage/company',
    name: 'Firmenmanager',
    component: CompanyManager,
    props: true,
  },
  {
    path: '/admin/companies',
    redirect: '/admin/companies/1',
  },
  {
    path: '/admin/companies/:page',
    name: 'AdminCompanies',
    component: AdminCompanies,
    props: true,
    beforeEnter
  },
  {
    path: '/admin/challenges/:companyIdentifier',
    name: 'ManageChallenges',
    component: ManageChallenges,
    props: true,
    beforeEnter
  },
  {
    path: '/admin/text',
    name: 'AdminText',
    component: ManageText,
    props: false,
    beforeEnter
  },
  {
    path: '/admin/runs',
    redirect: '/admin/runs/1',
  },
  {
    path: '/admin/runs/:page',
    name: 'AdminRuns',
    component: AdminRuns,
    props: true,
    beforeEnter
  },
  {
    path: '/embedded',
    name: 'embedded',
    component: Embedded,
    props: true,
    meta: {embedded:true },
    beforeEnter
  }
]

const router = new VueRouter({
  routes,
  /*scrollBehavior (to, from, savedPosition) {
    savedPosition = savedPosition || {x: 0, y: 0};

    document.body.scrollTop = savedPosition.y; // For Safari
    document.documentElement.scrollTop = savedPosition.y;
  }*/
})

export default router
